import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  card: {
    marginBottom: 16,
    width: "100%",
  },
  title: {
    color: '#000'
  },
  content: {
    padding: '0 12px',
    "& p": {
      fontSize: 12,
      marginBottom: 16,
      position: 'relative',
      padding: '0 14px',
      "&:before": {
        content: "''",
        position: 'absolute',
        left: 0,
        width: 8,
        height: 8,
        top: 5,
        borderRadius: '50%',
        background: '#CAD4DD'
      }
    },
  },
  cardContent: {
    borderRadius: 5,
    border: 'solid 1px #E3EBF2',
    background: '#FEFEFE'
  },
  start: {
    borderLeft: "solid 4px #30CCA8",
  },
  pause: {
    borderLeft: "solid 4px #FE8585",
  },
  continue: {
    borderLeft: "solid 4px #D5D5D5",
  },
  emptyState: {
    height: 270,
    padding: '0 60px',
    "& h6": {
      color: '#8C9CAC',
      marginBottom: 15,
      marginTop: 8
    },
    "& svg": {
      marginRight: -16
    }
  }
}));
